// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".g6-tooltip{padding:10px 6px;color:#444;background-color:hsla(0,0%,100%,.9);border:1px solid #e2e2e2;border-radius:4px}", ""]);
// Exports
module.exports = exports;
